import axiosInstance from "../../api/auth/axiosInstance";
export const saveBooking = async (bookingData) => {
  try {
    const response = await axiosInstance.post(`/bookings/`, bookingData,{
      headers: { authType: "PostLogin" }
    });
   
    return response.data.data;
  } catch (error) {
    console.error('Booking failed', error);
    throw error;
  }
};